import * as types from '../types.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: center; }
			.view td:nth-child(7)	{ text-align: left; max-width: 40rem; }
			.view td:nth-child(8)	{ text-align: center; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="4" data-visible="${this.visible[2]}">Tipo</th>
					<th data-index="6" data-visible="${this.visible[3]}">Recibo</th>
					<th data-index="8" data-visible="${this.visible[4]}">Código</th>
					<th data-index="9" data-visible="${this.visible[5]}">Mensagem</th>
					<th data-index="10" data-visible="${this.visible[6]}">Data/Hora</th>
					<th data-index="5" data-visible="${this.visible[7]}">Estado</th>
					<th data-index="3" data-visible="${this.visible[8]}">Ambiente</th>
					<th data-index="12" data-visible="${this.visible[9]}">Contingência</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${this.option(types.opt_invoice_lot_type(), record.type)}</td>
					<td data-visible='${this.visible[3]}'>${record.receipt || ''}</td>
					<td data-visible='${this.visible[4]}'>${record.result_code || ''}</td>
					<td data-visible='${this.visible[5]}'>${record.result_text || ''}</td>
					<td data-visible='${this.visible[6]}'>${this.format(types.datetime(), record.result_datetime) || ''}</td>
					<td data-visible='${this.visible[7]}'>${this.option(types.opt_uf(), record.state)}</td>
					<td data-visible='${this.visible[8]}'>${this.option(types.opt_environment(), record.environment)}</td>
					<td data-visible='${this.visible[9]}'>${this.option(types.opt_bool(), record.in_contingency)}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

